import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import { Close } from 'mdi-material-ui'
import logo from '../assets/logo.png'

const styles = {
  root: {
    flexGrow: 1,
  },
  title: {
    marginLeft: 24,
    flex: 1,
  }
}

class MainAppBar extends React.Component {
  state = {
    auth: true,
    anchorEl: null,
  }

  handleChange = (event, checked) => {
    this.setState({auth: checked})
  }

  handleTelemetryClose = () => {
    this.props.handleTelemetryClose()
  }

  render () {
    const {classes} = this.props

    return (
      <AppBar position="static">
        <Toolbar>
          <img src={logo} alt = "logo" width={'32'} height={'32'}/>
          <Typography variant="title" color="inherit" className={classes.title}>
            Rally Live Maps
          </Typography>
        </Toolbar>
      </AppBar>
    )
  }
}

MainAppBar.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(MainAppBar)


// WEBPACK FOOTER //
// ./src/views/MainAppBar.js